import { EntityState } from '@ngrx/entity';
import { ConversationToastMessage } from './models/conversation-toast-message.model';

export interface GenesysCloudConversationToastMessagesSubState {
  [conversationId: string]: EntityState<ConversationToastMessage>;
}

export interface GenesysCloudCommonConversationsState {
  toastMessages: GenesysCloudConversationToastMessagesSubState
}

export const initialConversationToastMessageSubState = (): GenesysCloudConversationToastMessagesSubState => ({});
export const initialState = (): GenesysCloudCommonConversationsState => ({
  toastMessages: initialConversationToastMessageSubState()
});
